class NewFaq extends HTMLElement {
  constructor() {
    super();

    this.items = Array.from(this.querySelectorAll('[data-new-faq-item]'));
    this.allowMultipleOpen = this.dataset.allowMultipleOpen === 'true';
    this.onButtonClick = this.onButtonClick.bind(this);

    this.items.forEach((item) => {
      const button = item.querySelector('[data-new-faq-button]');
      const panel = item.querySelector('[data-new-faq-panel]');

      if (!button || !panel) {
        return;
      }

      if (item.classList.contains('new-faq__item--open')) {
        panel.hidden = false;
        panel.style.height = 'auto';
      }
      else {
        panel.hidden = true;
        panel.style.height = '0px';
      }

      button.addEventListener('click', this.onButtonClick);
    });
  }

  onButtonClick(event) {
    const currentItem = event.currentTarget.closest('[data-new-faq-item]');

    if (!currentItem) {
      return;
    }

    const isOpen = currentItem.classList.contains('new-faq__item--open');

    if (isOpen) {
      this.closeItem(currentItem);
      return;
    }

    if (!this.allowMultipleOpen) {
      this.items.forEach((item) => {
        if (item !== currentItem) {
          this.closeItem(item);
        }
      });
    }

    this.openItem(currentItem);
  }

  openItem(item) {
    const button = item.querySelector('[data-new-faq-button]');
    const panel = item.querySelector('[data-new-faq-panel]');

    if (!button || !panel || item.classList.contains('new-faq__item--open')) {
      return;
    }

    item.classList.add('new-faq__item--open');
    button.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    panel.style.height = '0px';

    window.requestAnimationFrame(() => {
      panel.style.height = `${panel.scrollHeight}px`;
    });

    this.afterTransition(panel, () => {
      if (item.classList.contains('new-faq__item--open')) {
        panel.style.height = 'auto';
      }
    });
  }

  closeItem(item) {
    const button = item.querySelector('[data-new-faq-button]');
    const panel = item.querySelector('[data-new-faq-panel]');

    if (!button || !panel || !item.classList.contains('new-faq__item--open')) {
      return;
    }

    panel.style.height = `${panel.scrollHeight}px`;
    void panel.offsetHeight;
    item.classList.remove('new-faq__item--open');
    button.setAttribute('aria-expanded', 'false');

    window.requestAnimationFrame(() => {
      panel.style.height = '0px';
    });

    this.afterTransition(panel, () => {
      if (!item.classList.contains('new-faq__item--open')) {
        panel.hidden = true;
      }
    });
  }

  afterTransition(panel, callback) {
    const transitionDuration = window.getComputedStyle(panel).transitionDuration;

    if (transitionDuration === '0s') {
      callback();
      return;
    }

    panel.addEventListener(
      'transitionend',
      (event) => {
        if (event.target === panel && event.propertyName === 'height') {
          callback();
        }
      },
      { once: true }
    );
  }
}

if (!customElements.get('new-faq')) {
  customElements.define('new-faq', NewFaq);
}
